import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3475d296&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3475d296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3475d296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3475d296')) {
      api.createRecord('3475d296', component.options)
    } else {
      api.reload('3475d296', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3475d296&scoped=true&", function () {
      api.rerender('3475d296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/iiko-access/components/access-sidesheet/index.vue"
export default component.exports